import { create } from 'zustand';

// useIdleTimeout ile ayni anahtar. Hareketsizlik damgasi localStorage'da
// yasiyor ve TARAYICI KAPANINCA SILINMIYOR - bu yuzden oturum baslarken
// tazelenmezse, dun aksamdan kalma damgayi goren idle guard kullaniciyi
// giristen hemen sonra disari atiyordu ("her sabah ilk girişte atıyor").
// Yeni bir oturum her zaman sifirdan 1 saatlik pencere ile baslamali.
const IDLE_ACTIVITY_KEY = 'arys_last_activity';

const useAuthStore = create((set) => ({
  user:            JSON.parse(localStorage.getItem('user') || 'null'),
  isAuthenticated: !!localStorage.getItem('user'),

  // Impersonation state — sessionStorage: sekme kapanınca temizlenir
  originalUser:    JSON.parse(sessionStorage.getItem('originalUser') || 'null'),
  impersonationId: sessionStorage.getItem('impersonationId') ? Number(sessionStorage.getItem('impersonationId')) : null,
  isImpersonating: !!sessionStorage.getItem('originalUser'),

  login: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    // Taze oturum = taze hareketsizlik penceresi (bkz. IDLE_ACTIVITY_KEY notu).
    localStorage.setItem(IDLE_ACTIVITY_KEY, String(Date.now()));
    set({ user, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('user');
    localStorage.removeItem(IDLE_ACTIVITY_KEY);
    sessionStorage.removeItem('originalUser');
    sessionStorage.removeItem('impersonationId');
    set({ user: null, isAuthenticated: false, originalUser: null, impersonationId: null, isImpersonating: false });
  },

  updateUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    set({ user });
  },

  startImpersonation: (impersonatedUser, impersonationId) => {
    const currentUser = localStorage.getItem('user');
    sessionStorage.setItem('originalUser', currentUser);
    sessionStorage.setItem('impersonationId', String(impersonationId));
    localStorage.setItem('user', JSON.stringify(impersonatedUser));
    set({
      user:            impersonatedUser,
      originalUser:    JSON.parse(currentUser),
      impersonationId: impersonationId,
      isImpersonating: true,
    });
  },

  stopImpersonation: (adminUser) => {
    localStorage.setItem('user', JSON.stringify(adminUser));
    sessionStorage.removeItem('originalUser');
    sessionStorage.removeItem('impersonationId');
    set({
      user:            adminUser,
      originalUser:    null,
      impersonationId: null,
      isImpersonating: false,
    });
  },
}));

export default useAuthStore;
